<template>
  <div class="merchant-detail">
    <div class="personal-info-panel" v-if="userInfo.bussType === 2">
      <div class="header">
        <div class="block"></div>
        <div class="name">{{ userInfo.fullName }}</div>
        <div class="status real">{{ userInfo.typesDesc }}</div>
        <div class="record" @click="goRecord">增机记录</div>
      </div>
      <div class="top">
        <div class="head-img">
          <img src="@/assets/img/icon-head.png" alt="" />
        </div>
        <div class="name">
          <span>
            {{ userInfo.fullName }}
          </span>
        </div>
        <div class="phone" v-if="userInfo.telShowFlag == 1">
          <img src="@/assets/img/icon-phone.png" @click="callPhone" />
        </div>
        <!-- <div class="message" v-if="userInfo.telShowFlag == 1">
          <img src="@/assets/img/icon-message.png" @click="sendMsg" />
        </div> -->
      </div>
      <div class="bottom">
        <!-- <div class="create-time">
          <div>商户编号</div>
          <div>
            {{ userInfo.merchant_no }}
          </div>
        </div> -->
        <div class="create-time">
          <div>入网时间</div>
          <div>
            {{ userInfo.createTime | dateFormat('YYYY-mm-dd HH:MM:SS') }}
          </div>
        </div>
        <div class="wp-info">
          <div>
            <div>商户地址</div>
            <div>{{ userInfo.addr || '' }}</div>
          </div>
          <div>
            <div>商户登录名</div>
            <div>{{ userInfo.loginName || '' }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="personal-info-panel" v-else>
      <div class="top">
        <div class="head-img">
          <img src="@/assets/img/icon-head.png" alt="" />
        </div>
        <div class="name">
          <span>
            {{ userInfo.fullName }}
          </span>
          <div class="status real">{{ userInfo.typesDesc }}</div>
        </div>
        <div class="phone" v-if="userInfo.telShowFlag == 1">
          <img src="@/assets/img/icon-phone.png" @click="callPhone" />
        </div>
        <!-- <div class="message" v-if="userInfo.telShowFlag == 1">
          <img src="@/assets/img/icon-message.png" @click="sendMsg" />
        </div> -->
      </div>
      <div class="bottom">
        <!-- <div class="create-time">
          <div>商户编号</div>
          <div>
            {{ userInfo.merchant_no }}
          </div>
        </div> -->
        <div class="create-time">
          <div>入网时间</div>
          <div>
            {{ userInfo.firstTime | dateFormat('YYYY-mm-dd HH:MM:SS') }}
          </div>
        </div>
      </div>
    </div>
    <van-tabs v-model="active" @click="changeTab">
      <van-tab name="1" title="他/她的设备">
        <div v-if="machineObj && JSON.stringify(machineObj) != '{}'">
          <div v-if="userInfo.bussType === 2">
            <div v-for="(item, index) in machineObj" :key="index" class="list">
              <div>{{ index }}</div>
              <div v-for="(v, key) in item" :key="key" class="item">
                <div>设备编号：{{ v.sn }}</div>
                <div>授权码：{{ v.auth_code }}</div>
                <div>
                  授权码使用状态：{{ v.authCodeStatus ? '已使用' : '未使用' }}
                </div>
                <div>
                  激活时间：{{
                    v.activeTime | dateFormat('YYYY-mm-dd HH:MM:SS')
                  }}
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div v-for="(item, index) in machineObj" :key="index" class="list">
              <div>{{ index }}</div>
              <div v-for="(v, key) in item" :key="key" class="item">
                <div>设备编号：{{ v.sn }}</div>
                <div>
                  激活时间：{{
                    v.activeTime | dateFormat('YYYY-mm-dd HH:MM:SS')
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="no-found">
          <img src="@/assets/img/img-nofound.png" alt="" />
          暂无数据哦~
        </div>
      </van-tab>
      <van-tab name="2" title="他/她的交易">
        <div class="calendar-selector" @click="showCalendar = true">
          <div class="selector">
            {{ startDate }} - {{ endDate }}
            <div class="icon">
              <img src="@/assets/img/icon-calendar.png" alt="" />
            </div>
          </div>
        </div>
        <transaction-data
          :showSelect="false"
          :tradeList="tradeList"
          :allMoney="allMoney"
          :thirtyDayFlag="businessDetails.thirtyDayFlag"
          :businessId="businessId"
        ></transaction-data>
        <van-calendar
          v-model="showCalendar"
          type="range"
          :default-date="defaultDate"
          :min-date="minDate"
          :max-range="31"
          :allow-same-day="true"
          color="#ecc381"
          @confirm="confirmCalendar"
          @close="onCloseCalendar"
        />
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import transactionData from '@/views/biz-components/transaction-data.vue'
import { dateFormat, platformAgent } from '@/utils/utils'
import {
  fetchBusinessBaseInfo,
  fetchBusinessDetails,
  fetchChangepartner,
  fetchBusinessTel
} from '@/api/merchant/merchant'
export default {
  components: { transactionData },
  filters: {
    dateFormat
  },
  data() {
    return {
      businessId: this.$route.query.businessId,
      active: 0,
      showCalendar: false,
      startDate: '',
      endDate: '',
      minDate: new Date('2021-08-23'),
      maxDate: new Date(),
      defaultDate: [],
      userInfo: {},
      machineList: [],
      machineObj: {},
      tradeList: [],
      businessDetails: {},
      allMoney: 0
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      const that = this
      const start = new Date(this.getCurrMonthFirst())
      const end = new Date()
      this.startDate = this.formatDate(start)
      this.endDate = this.formatDate(end)
      this.defaultDate = [start, end]
      fetchBusinessBaseInfo({
        businessId: this.businessId
      }).then(res => {
        this.userInfo = res || {}
        console.log('baseinfo:', this.userInfo)
        if (this.userInfo.changePartnerFlag === 1) {
          SyHybridSdk.setNavRightBtn({
            params: {
              isShow: 1,
              label: '商户转移',
              func() {
                that.getChangepartner()
              }
            },
            success: res => {}
          })
        } else if (this.userInfo.changePartnerFlag === 0) {
          SyHybridSdk.setNavRightBtn({
            params: {
              isShow: 1,
              label: '增机',
              func() {
                that.goZJ()
              }
            },
            success: res => {}
          })
        }
      })
      this.queryInfo()
    },
    queryInfo() {
      fetchBusinessDetails({
        businessId: this.businessId,
        startDate: this.startDate,
        endDate: this.endDate
      }).then(res => {
        console.log(res)
        this.businessDetails = res || {}
        this.machineList = res.machineList || []
        this.tradeList = res.tradeDetail || []
        this.allMoney = res.allMoney || 0
        this.groupMachineList()
      })
    },
    groupMachineList() {
      let obj = {}
      for (let item of this.machineList) {
        if (obj[item.name]) {
          obj[item.name].push(item)
        } else {
          obj[item.name] = [item]
        }
      }
      this.machineObj = obj
    },
    callPhone() {
      fetchBusinessTel({
        businessId: this.businessId
      }).then(res => {
        console.log('phone: ', res)
        SyHybridSdk.callPhone({
          params: {
            phone: res.tel
          },
          success: res => {}
        })
      })
    },
    sendMsg() {
      SyHybridSdk.sendMsg({
        params: {
          phone: this.userInfo.telephone,
          content: ''
        },
        success: res => {}
      })
    },
    changeTab(name, title) {
      this.tabName = name
    },
    confirmCalendar(date) {
      const [start, end] = date
      this.showCalendar = false
      this.startDate = this.formatDate(start)
      this.endDate = this.formatDate(end)
      this.queryInfo()
    },
    onCloseCalendar() {},
    formatDate(date) {
      return dateFormat(date.getTime(), 'YYYY-mm-dd')
    },
    getChangepartner() {
      const that = this
      fetchChangepartner({
        businessId: this.businessId
      }).then(res => {
        console.log('商户转移', res)
        let params = {}
        // 商户转移
        if (platformAgent() === 'ios') {
          params = {
            hostName: 'WYPTransferMerchantVC',
            name: that.userInfo.realName,
            phoneNumberStr: that.userInfo.telephone,
            businessId: that.businessId,
            isSearch: 0,
            changeArray: res
          }
        } else {
          params = {
            hostName:
              'com.jiuhongpay.worthplatform.mvp.ui.activity.TransferMerchantActivity',
            name: that.userInfo.realName,
            phone: that.userInfo.telephone,
            businessId: that.businessId,
            initChangePartner: JSON.stringify(res)
          }
        }
        SyHybridSdk.openOriActivity({
          params,
          success: res => {}
        })
      })
    },
    goRecord() {
      // 增机记录
      const that = this
      let params = {}
      if (platformAgent() === 'ios') {
        params = {
          hostName: 'RaiseMachinesRecordViewController',
          businessId: that.businessId
        }
      } else {
        params = {
          hostName:
            'com.jiuhongpay.worthplatform.mvp.ui.activity.IncreasesMachineRecordsActivity',
          client_detail_data: that.businessId
        }
      }
      SyHybridSdk.openOriActivity({
        params,
        success: res => {}
      })
    },
    goZJ() {
      // 增机
      const that = this
      that.businessDetails['id'] = that.businessId
      that.businessDetails['fullName'] = that.userInfo.fullName
      that.businessDetails['realName'] = that.userInfo.realName
      console.log(that.businessDetails)
      let params = {}
      if (platformAgent() === 'ios') {
        params = {
          hostName: 'RaiseMachinesViewController',
          businessModel: that.businessDetails
        }
      } else {
        params = {
          hostName:
            'com.jiuhongpay.worthplatform.mvp.ui.activity.AddMachineActivity',
          client_detail_data: that.businessId,
          device_person: that.userInfo.realName,
          device_name: that.userInfo.fullName
        }
      }
      SyHybridSdk.openOriActivity({
        params,
        success: res => {
          if (res) {
            console.log(res)
            that.queryInfo()
          }
        }
      })
    },
    // 获取当月1号
    getCurrMonthFirst() {
      var myDate = new Date()
      var tYear = myDate.getFullYear()
      var tMonth = myDate.getMonth() + 1
      tMonth = this.doHandleZero(tMonth)

      return tYear + '-' + tMonth + '-01'
    },
    // 补零函数
    doHandleZero(zero) {
      var date = zero
      if (zero.toString().length == 1) {
        date = '0' + zero
      }
      return date
    }
  }
}
</script>
